import {FileModel} from "@renta-apps/athenaeum-toolkit";
import {AttachmentType} from "@/models/Enums";

export default class AddConstructionSiteAttachmentsRequest{

    public constructionSiteId: string = "";

    public public: boolean = false;

    public type: AttachmentType = AttachmentType.ConstructionSiteAttachment;

    public files: FileModel[] = [];

    public readonly isAddConstructionSiteAttachmentsRequest: boolean = true;
}